module.exports = __webpack_public_path__ + "media/images/prizeBox__fg-99e6faa9e16a5bea29180a884e2e057b.png";